import axios from "axios";
import config from "../../settings";

export const manualUploadAPI = {
    importFile: (fileContent, annotations, fileName, authorizationCode, thenCallback) => {
         //axios.post(`${config.baseUrl}${config.importFile}${config.importFileCode}`, fileContent, {
        axios.post(`${config.baseUrl}${config.importFile}${config.importFileCode}&authorizationCode${authorizationCode}`, fileContent, {
                headers: {
                    'Content-Type': 'text/plain'
                  },
                  params: {
                    annotations: annotations,
                    fileName: fileName,
                    insertDate: new Date()
                  }
            })
            .then(res => {
                thenCallback(res.data);
            })
            //.catch((error) => {
            .catch(function(error){

                if(error.response.status === '401'){
                    window.sessionStorage.removeItem('user');
                    window.sessionStorage.removeItem('code');
                    window.sessionStorage.clear();
                    //window.location.href = '/Unauthorized';
                    window.location.href= "/unauthorized";
                }
                if(error.response && error.response.data && error.response.data.length > 0)
                {
                    thenCallback(error.response.data);
                }
                console.log(error);
            })
    },

    getRequestsByDateAndUser: (from, to, user, thenCallback) => {
        axios.get(`${config.baseUrl}${config.getRequestsByDateAndUser}`, {
            headers: { 'Content-Type': 'application/json'},
                  params: {
                    from: from,
                    to: to,
                    user: user
                  }
            })
            .then(res => {
                thenCallback(res.data);
            })
            .catch(err => {
                console.log(err);
            })
    },

    getRequestsBySearchFilter: (searchFilter, thenCallback) => {
        var url =`${config.baseUrl}${config.getRequestsBySearchFilter}`;
        axios.post(url, searchFilter, {
            headers: { 'Content-Type': 'application/json'}
        })
            .then(res => {
                thenCallback(res.data);
            })
            .catch(err => {
                console.log(err);
            })
    },

    getRequestsTypes: (thenCallback) => {
        axios.get(`${config.baseUrl}${config.getRequestsTypes}`)
            .then(res => {
                thenCallback(res.data);
            })
            .catch(err => {
                console.log(err);
            })
    },

    getRequestsUsers: (thenCallback) => {
        axios.get(`${config.baseUrl}${config.getRequestsUsers}`)
            .then(res => {
                thenCallback(res.data);
            })
            .catch(err => {
                console.log(err);
            })
    },

    getRequestsStatusList: (thenCallback) => {
        axios.get(`${config.baseUrl}${config.getRequestsStatusList}`)
            .then(res => {
                thenCallback(res.data);
            })
            .catch(err => {
                console.log(err);
            })
    },

    getFileByReqId: (id, thenCallback) => {
        axios.get(`${config.baseUrl}${config.getFileByReqId}`, {
                  responseType: 'arraybuffer',
                  params: {
                    id: id
                  }
            })
            .then(res => {
                thenCallback(res.data);
            })
            .catch(err => {
                console.log(err);
            })
    }
}